import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// ══════════════════════════════════════════════════════════════════
//  API SERVICE - LexSovereign Frontend
// ══════════════════════════════════════════════════════════════════

class ApiService {
  // ── AUTH ──────────────────────────────────────────────────────────
  async login(email, password) {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    return response.data;
  }

  async verifySession(token) {
    const response = await axios.get(`${API}/auth/me`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  }

  async getRoles() {
    const response = await axios.get(`${API}/auth/roles`);
    return response.data;
  }

  // ── CASOS ─────────────────────────────────────────────────────────
  async getCasos(rol) {
    const response = await axios.get(`${API}/casos`, { params: { rol } });
    return response.data;
  }

  async getCaso(casoId, rol) {
    const response = await axios.get(`${API}/casos/${casoId}`, { params: { rol } });
    return response.data;
  }

  async createCaso(caso, rol) {
    const response = await axios.post(`${API}/casos`, caso, { params: { rol } });
    return response.data;
  }

  // ── ALERTAS ───────────────────────────────────────────────────────
  async getAlertas(rol) {
    const response = await axios.get(`${API}/alertas`, { params: { rol } });
    return response.data;
  }

  async createAlerta(alerta, rol) {
    const response = await axios.post(`${API}/alertas`, alerta, { params: { rol } });
    return response.data;
  }

  // ── DOCUMENTOS ────────────────────────────────────────────────────
  async getDocumentos(rol, casoId = null) {
    const params = { rol };
    if (casoId) params.caso_id = casoId;
    const response = await axios.get(`${API}/documentos`, { params });
    return response.data;
  }

  async analizarDocumento(documento, rol) {
    const response = await axios.post(`${API}/documentos/analizar`, documento, { params: { rol } });
    return response.data;
  }

  // ── COLABORACIÓN ──────────────────────────────────────────────────
  async getMensajes(rol, limit = 50) {
    const response = await axios.get(`${API}/colaboracion/mensajes`, { params: { rol, limit } });
    return response.data;
  }

  async createMensaje(mensaje, hora) {
    const response = await axios.post(`${API}/colaboracion/mensajes`, mensaje, { params: { hora } });
    return response.data;
  }

  // ── IA ────────────────────────────────────────────────────────────
  async consultaIA(pregunta, rol, casoId = null) {
    const response = await axios.post(`${API}/ia/consulta`, {
      pregunta,
      rol,
      caso_id: casoId
    });
    return response.data.respuesta;
  }

  async generarBriefing(idioma, clienteId, rol) {
    const response = await axios.post(`${API}/ia/briefing`, {
      idioma,
      cliente_id: clienteId,
      rol
    });
    return response.data.briefing;
  }

  // ── HEALTH ────────────────────────────────────────────────────────
  async health() {
    const response = await axios.get(`${API}/health`);
    return response.data;
  }

  // ── ACTUALIZACIONES IA ────────────────────────────────────────────
  async submitActualizacion(tipo, textoLibre, casoId, submittedBy) {
    const response = await axios.post(`${API}/actualizaciones/submit`, {
      tipo,
      texto_libre: textoLibre,
      caso_id: casoId,
      submitted_by: submittedBy
    });
    return response.data;
  }

  async getActualizacionesPendientes(rol) {
    const response = await axios.get(`${API}/actualizaciones/pendientes`, { params: { rol } });
    return response.data;
  }

  async aprobarActualizacion(updateId, aprobado, comentario, aprobadoPor) {
    const response = await axios.post(`${API}/actualizaciones/${updateId}/aprobar`, {
      aprobado,
      comentario,
      aprobado_por: aprobadoPor
    });
    return response.data;
  }
}

export default new ApiService();